import { Link } from "@tanstack/react-router";

/** アカウント設定メールの再送（/signin-email）とサインインへの導線 */
function ResendOrSignInLinks() {
  return (
    <div className="w-fit grid grid-cols-[350px_150px] text-sm gap-2 mt-8 mx-auto">
      <p>
        URLの有効期限が過ぎた場合はこちらからメールを再送してご登録をお願いします
      </p>
      <p className="text-slate-600 underline">
        <Link to="/signin-email">アカウントメール再送</Link>
      </p>
      <p>すでにアカウント登録が完了されている方はこちら</p>
      <p className="text-slate-600 underline">
        <Link to="/signin">サインイン</Link>
      </p>
    </div>
  );
}

export default ResendOrSignInLinks;
